const _package = require('../../package.json')
const store_name = `useryaa-${_package.version}`

export function authHeader() {
	// return authorization header with jwt token
	let user = JSON.parse(localStorage.getItem(`${store_name}`))

	if (user && user.token) {
		// return { 'Authorization': 'Bearer ' + user.token };
		return {
			'Content-Type': 'application/json',
			Authorization: user.token,
		}
	} else {
		return {
			'Content-Type': 'application/json',
		}
	}
}
